const axios = require('axios');

export async function fetchCurrentDate(locationId) {
  try {
    const url = `${process.env.REACT_APP_BOOKING_APP_API_URL}/location/${locationId}`;
    const response = await axios.get(url);

    return response.data.currentDateTime;
  } catch (error) {
    console.error(`Error fetching date for location ${locationId}:`, error);
  }
}
